/**
 * Style variants for the theme system.
 * Each style adjusts spacing and radius scales for different visual aesthetics.
 */

export type Style = 'vega' | 'nova' | 'maia' | 'lyra' | 'mira'

export interface StyleDefinition {
  id: Style
  name: string
  description: string
  icon: 'square' | 'minimize' | 'circle' | 'octagon' | 'grid'
  css: {
    spacingScale: number
    radiusScale: number
  }
}

export const STYLES: StyleDefinition[] = [
  {
    id: 'vega',
    name: 'Vega',
    description: 'The classic shadcn/ui look. Clean, neutral, and familiar.',
    icon: 'square',
    css: {
      spacingScale: 1,
      radiusScale: 1,
    },
  },
  {
    id: 'nova',
    name: 'Nova',
    description: 'Reduced padding and margins for compact layouts.',
    icon: 'minimize',
    css: {
      spacingScale: 0.875,
      radiusScale: 0.875,
    },
  },
  {
    id: 'maia',
    name: 'Maia',
    description: 'Soft and rounded, with generous spacing.',
    icon: 'circle',
    css: {
      spacingScale: 1.125,
      radiusScale: 1.5,
    },
  },
  {
    id: 'lyra',
    name: 'Lyra',
    description: 'Boxy and sharp. Pairs well with mono fonts.',
    icon: 'octagon',
    css: {
      spacingScale: 1,
      radiusScale: 0.25,
    },
  },
  {
    id: 'mira',
    name: 'Mira',
    description: 'Compact. Made for dense interfaces.',
    icon: 'grid',
    css: {
      spacingScale: 0.75,
      radiusScale: 0.75,
    },
  },
]

export function getStyleById(id: Style): StyleDefinition | undefined {
  return STYLES.find((s) => s.id === id)
}
